import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const CustomHeaderContainer = styled.div`
  width: 100%;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;

export const SubmissionTypesList = styled.div`
  height: 70%;
  width: 100%;
  overflow: auto;
`;
